import request from '@/utils/request';
import { EU_IPS } from './const';
import { useEffect } from 'react';

// https://ecoflow.feishu.cn/docx/CpeOdkWaGoLxaJxVBKPccmM3nQe

const readyLangsFullSite = JSON.parse(process.env.NEXT_PUBLIC_READY_LANG_FULL_SITE || '[]');

const _getIsEuOrUs = (countryCode: string) => {
    return EU_IPS.includes(countryCode.toLowerCase()) ? 'eu' : 'us';
};

// 商品包装组那边二维码直接是 www.ecoflow.com/support, 并没有区分不同国家和站点，这里需要根据用户IP地址解析不同国家。
// 1. 如IP地址为官网已有站点，则自动补全为所在站点，如法国解析为: www.ecoflow.com/fr/support；
// 2. 如果IP地址为欧洲国家且官网没有对应的站点，则自动补全为欧洲站 /eu, 如瑞士解析为: www.ecoflow.com/eu/support；
// 3. 如果IP地址为非欧洲国家且官网没有对应站点，则自动补全为美国站 /us, 如缅甸解析为: www.ecoflow.com/us/support；
export const redirectQRUsEu = async (route: string) => {
    if (typeof window === 'undefined') return;
    const path = window.location.pathname;
    if (path !== route) return;
    const apiUrl = process.env.NEXT_PUBLIC_LOGIN_HOST;
    const macIPRes = await request.get(`${apiUrl}/website/address/finGeoByIp`);
    if (macIPRes?.code === '0') {
        const macIP = macIPRes.data || { countryCode: 'US' };
        let countryCode = macIP?.countryCode?.toLowerCase();
        const COUNTRY_CODE_MAP = {
            ...readyLangsFullSite.reduce((prev: any, cur: any) => ({ ...prev, [cur]: cur }), {}),
            gb: 'uk',
            ru: 'cis',
            sa: 'sa',
        };
        let ipLocale = COUNTRY_CODE_MAP[countryCode] ? COUNTRY_CODE_MAP[countryCode] : _getIsEuOrUs(macIP?.countryCode);
        window.location.href = `/${typeof ipLocale == 'string' ? ipLocale : 'us'}${path}`;
    } else {
        window.location.href = `/us${path}`;
    }
};

const IPRedirectLocal: React.FC<{ route: string }> = ({ route }) => {
    useEffect(() => {
        redirectQRUsEu(route);
    }, []);
    return <></>;
};

export default IPRedirectLocal;
